import { Button } from "react-bootstrap";
import { DateHelper, StringHelper } from "../../../../../helper";
import { requestTypes } from "../../../../../constants";
import classNames from "classnames";
import { FontFa } from "../../../../../components";
import { transform } from "../utils/transform";
import { useMTPSSteps } from "./use-MTPS-steps";
import { MTPExcelJSService } from "../../monthly-training-plan/services/MTPExcelJS.service";

export const useMTPSColumns = () => {
  const { approve } = useMTPSSteps();

  const columns = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
    },
    {
      title: "Người tạo",
      dataIndex: "eCreatedBy",
      key: "eCreatedBy",
      render: (text: string) =>
        StringHelper.verticalBarSplit<string[]>(text)[1],
    },
    {
      title: "Yêu cầu",
      dataIndex: "eRequestType",
      key: "eRequestType",
      render: (text: string) => (
        <div className="flag success">{requestTypes[text]}</div>
      ),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      render: (text: string, record: any) => {
        const { status } = approve(record?.eApprovalProcess);
        return (
          <div className={classNames("flag", status.flag)}>{status.label}</div>
        );
      },
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <Button
          title="Xuất file"
          variant="outline-danger"
          onClick={(e: any) => {
            e.stopPropagation();
            const instance = new MTPExcelJSService();
            instance.create(transform(record.eContent));
            instance.download(`Bảng tổng hợp kế hoạch đào tạo tháng`);
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      ),
    },
  ];
  return { columns };
};
